import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { AuthenticationLayout } from 'Views/Authentication/Components/AuthenticationLayout';
import { CircularProgress } from '@mui/material';

const useStyles = buildUseStyles('AuthenticationLayoutLoading', (theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapperDesktop: {
    width: 500,
    padding: theme.spacing(4, 8),
  },
  wrapperMobile: {
    padding: theme.spacing(2, 3),
    maxWidth: 'min(100vw, 500px)',
  },
}));

export const AuthenticationLayoutLoading = () => {
  const isMobile = useMobileLayout();
  const classes = useStyles();
  return (
    <AuthenticationLayout>
      <div
        className={classNames(classes.wrapper, {
          [classes.wrapperDesktop]: !isMobile,
          [classes.wrapperMobile]: isMobile,
        })}
      >
        <CircularProgress size={60} color={'inherit'} />
      </div>
    </AuthenticationLayout>
  );
};
